(function(){
    angular
        .module('appback')
        .directive('ngHtvet', htvet);

        htvet.$inject = ['$timeout'];
        function htvet($timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/web/app/analiticas/htvet.html',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  //sub: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : {  }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { }};
				            }else{
				            	if(!scope.item.resultado.extra.resultado){
				            		scope.item.resultado.extra.resultado = { };
					            }else{
					            	if(Array.isArray(scope.item.resultado.extra.resultado)){
				            			scope.item.resultado.extra.resultado = { };
					            	}
				       				//console.log("resmd");
				       				//console.log(scope.item.resultado.extra.resultado);

					            }
				            }
				        }
			        });
		        }
          }
      }
})();